<template>
  <div class="painpoint">
    <div class="header">
      <div class="title">社区管理痛点</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in painpointList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import communityadminpainpoint1 from "../../../../assets/programme/communityadminpainpoint1.png";
import communityadminpainpoint2 from "../../../../assets/programme/communityadminpainpoint2.png";
import communityadminpainpoint3 from "../../../../assets/programme/communityadminpainpoint3.png";
import communityadminpainpoint4 from "../../../../assets/programme/communityadminpainpoint4.png";
import communityadminpainpoint5 from "../../../../assets/programme/communityadminpainpoint5.png";

export default {
  setup() {
    return reactive({
      painpointList: [
        {
          id: 1,
          title: "集中监管难",
          text: "管理的社区众多，各个社区系统不一致，无法集中监管",
          logo: communityadminpainpoint1,
        },
        {
          id: 2,
          title: "线下报表乱",
          text: "各个社区的报表要线下汇总，再统一上交，报表多、分类乱，难汇总",
          logo: communityadminpainpoint2,
        },
        {
          id: 3,
          title: "员工监管不到位",
          text: "无法远程监控到各个社区的员工是否按照规定执行",
          logo: communityadminpainpoint3,
        },
        {
          id: 4,
          title: "硬件设备成本高",
          text: "硬件设备成本高，维修频次无法评估",
          logo: communityadminpainpoint4,
        },
        {
          id: 5,
          title: "财务效率低",
          text: "各个社区的缴费项目多，需要财务长时间的统计",
          logo: communityadminpainpoint5,
        },
      ],
    });
  },
};
</script>

<style scoped>
.painpoint {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}
.body .list .item {
    width: 180px;
    text-align: center;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
    width: 180px;
}
.body .list .item .title {
    font-size: 18px;
    margin-top: 33px;
}
.body .list .item .text {
    color: #495A6C;
    font-size: 14px;
    margin-top: 8px;
    line-height: 24px;
}
</style>
